import React, { useEffect, useState } from 'react'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import { formatDate, getAllData, subtractDays } from '../../../shared/constants'

export default function AuditReport() {
  const [state, setState] = useState({
    data: [],
    loading: false,
    paginate: false,
    downloadData: false,
  })
  console.log({ STATE_DATA: state })

  const filterData = state.data
  const [page, setPage] = React.useState(1)

  useEffect(() => {
    getAllData('GET_AUDIT_REPORT', { page: page, limit: 10 }, state, setState)
  }, [page])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  if (!state.loading && filterData.length > 0) {
    tableBody = filterData.map((item) => {
      return [
        { value: item.rank6Name },
        { value: item.store.name },
        { value: item.area.name },
        { value: item.city.name },
        { value: item.district.name },
        { value: item.state.name },
        { value: item.zone.name },
        { value: item.region.name },
        { value: item.otherDetails && formatDate(item.otherDetails[0].auditDate) },
        { value: item.otherDetails && item.otherDetails[0].totalAuditScore },
        { value: item.otherDetails && item.otherDetails[0].modifiedAuditScore },
        { value: item.status.OPEN },
        { value: item.status.SUBMIT },
        { value: item.status.COMPLETE },
        { value: item.status.REOPEN },
        { value: item.totalTasks },
      ]
    })
  }

  const layoutProps = {
    heading: 'Open Audit Task Report',
    filename: 'open_audit_task_reports',
    headers: state.downloadData.headings,
    data: state.downloadData.headingValues,
  }

  return (
    // <>asas</>
    <CustomTableLayout
      tableHeadings={[
        'Employee NAme',
        // 'employee code',
        'store',
        // 'store code',
        'area',
        'city',
        'district',
        'state',
        'zone',
        'region',
        'last audit on',
        'total audit score',
        'audit score',
        'Open',
        'Submit',
        'Completed',
        'Reopen',
        'total tasks',
      ]}
      loading={state.loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: state.paginate.totalPage, page: page }}
      layoutProps={layoutProps}
    />
  )
}
